module.exports = __webpack_public_path__ + "assets/img/header.974de3b3.jpg";